import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { Field } from "@atlaskit/form";
import Select, { ValueType } from "@atlaskit/select";
import { N200 } from "@atlaskit/theme/colors";

import { fontSize } from "@/components/signup/utils";
import { ExistingSite } from "@/libraries/bxp-web-stargate-client/src";
import { wacToken } from "@/libraries/design/foundations";

import { useSiteActivationContext } from "../../../hooks/site-activation-context";

export const Dropdown = () => {
    const {
        sitePickerValue,
        setSitePickerValue,
        isSubmitting,
        isRequestInProgress,
        sitesWithoutCurrentProduct
    } = useSiteActivationContext();

    return (
        <div data-testid="adg4-site-picker" css={inputAndLabelStyles}>
            <Field<ValueType<ExistingSite>>
                aria-required
                isRequired
                defaultValue={sitesWithoutCurrentProduct[0]}
                isDisabled={isSubmitting}
                id="site-picker-field"
                name="site-picker-field"
                data-testId="site-picker-field"
                label={
                    <span
                        css={css({
                            color: N200,
                            fontWeight: 500
                        })}
                    >
                        <FormattedMessage
                            id="WacSignupForm.siteNameN2ELabel"
                            defaultMessage="Your site"
                        />
                    </span>
                }
            >
                {({ fieldProps: { id, ...rest } }) => (
                    <Select
                        {...rest}
                        inputId={id}
                        options={sitesWithoutCurrentProduct}
                        getOptionLabel={(option) =>
                            option.url.replace("https://", "")
                        }
                        getOptionValue={(option) => option.cloudId}
                        value={sitePickerValue}
                        onChange={(newValue) =>
                            setSitePickerValue(
                                newValue ?? sitesWithoutCurrentProduct[0]
                            )
                        }
                        isLoading={isRequestInProgress}
                        isSearchable={false}
                        styles={{
                            menu: (base) => ({
                                ...base,
                                fontSize: fontSize.md
                            }),
                            valueContainer: (base) => ({
                                ...base,
                                fontSize: fontSize.md,
                                paddingTop: "8px",
                                paddingRight: "6px",
                                paddingBottom: "8px",
                                paddingLeft: "6px"
                            }),
                            singleValue: (base) => ({
                                ...base,
                                margin: 0
                            })
                        }}
                    />
                )}
            </Field>
        </div>
    );
};

const inputAndLabelStyles = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "input": {
        fontSize: fontSize.md
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "label span:nth-of-type(2)": {
        display: "none"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["label + div > div:first-of-type, div[data-disabled]"]: {
        borderRadius: "21px"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["input, label + div > div > div"]: {
        paddingInlineStart: "12px !important"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["label > span"]: {
        color: wacToken("color.primary.black"),
        fontFamily: wacToken("font.charlie.text"),
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px"
    }
});
